module.exports = __webpack_public_path__ + "img/index01.6154d172.png";